import {FC, useState} from 'react';
import {Box, Button, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Typography,} from '@mui/material';
import {FormattedMessage, useIntl} from 'react-intl';
import AMPModal from 'src/components/common/AMPModal';
import {LinkBexioAccountModalProps} from './LinkBexioAccountModal.types';

export const LinkBexioAccountModal: FC<LinkBexioAccountModalProps> = ({
                                                                          open,
                                                                          onClose,
                                                                          onLink,
                                                                          availableAccounts,
                                                                          linkedAccountIds = [],
                                                                      }) => {
    const intl = useIntl();
    const [selectedAccountId, setSelectedAccountId] = useState<number | ''>('');

    // Filter out already linked accounts
    const unlinkedAccounts = availableAccounts.filter(
        account => !linkedAccountIds.includes(account.id)
    );

    const handleAccountChange = (event: SelectChangeEvent<number>) => {
        setSelectedAccountId(event.target.value as number);
    };

    const handleSubmit = () => {
        if (selectedAccountId !== '') {
            onLink(selectedAccountId as number);
            setSelectedAccountId('');
            onClose();
        }
    };

    const handleClose = () => {
        setSelectedAccountId('');
        onClose();
    };

    return (
        <AMPModal
            open={open}
            handleClose={handleClose}
            title={intl.formatMessage({id: 'linkNewBexioAccount'})}
            type="sm"
            fullWidth
        >
            <Box sx={{p: 3}}>
                {unlinkedAccounts.length > 0 ? (
                    <>
                        <Typography variant="body2" sx={{mb: 2}}>
                            <FormattedMessage id="selectBexioAccountToLink"/>
                        </Typography>

                        <FormControl fullWidth sx={{mb: 3}}>
                            <InputLabel
                                id="bexio-account-select-label"
                                sx={{
                                    '&.Mui-focused': {
                                        backgroundColor: 'white',
                                        px: 0.5,
                                    },
                                    '&.MuiInputLabel-shrink': {
                                        backgroundColor: 'white',
                                        px: 0.5,
                                    }
                                }}
                            >
                                <FormattedMessage id="bexioAccount"/>
                            </InputLabel>
                            <Select
                                labelId="bexio-account-select-label"
                                value={selectedAccountId}
                                label={intl.formatMessage({id: 'bexioAccount'})}
                                onChange={handleAccountChange}
                            >
                                {unlinkedAccounts.map((account) => (
                                    <MenuItem key={account.id} value={account.id}>
                                        {account.companyName} (ID: {account.id})
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <Box sx={{display: 'flex', justifyContent: 'flex-end', gap: 2}}>
                            <Button variant="outlined" onClick={handleClose}>
                                <FormattedMessage id="cancel"/>
                            </Button>
                            <Button
                                variant="contained"
                                onClick={handleSubmit}
                                disabled={!selectedAccountId}
                            >
                                <FormattedMessage id="link"/>
                            </Button>
                        </Box>
                    </>
                ) : (
                    <>
                        <Typography variant="body2" sx={{mb: 2}}>
                            <FormattedMessage id="noAvailableBexioAccounts"/>
                        </Typography>
                        <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
                            <Button variant="outlined" onClick={handleClose}>
                                <FormattedMessage id="close"/>
                            </Button>
                        </Box>
                    </>
                )}
            </Box>
        </AMPModal>
    );
};